export type RecipeAccessMeta = {
  locked?: boolean;
  unlocked?: boolean;
  is_locked?: boolean;
  access?: string;
  [key: string]: any;
};

export function isRecipeLocked(recipe: RecipeAccessMeta | null | undefined): boolean {
  if (!recipe) return false;

  if (typeof recipe.locked === 'boolean') return recipe.locked;
  if (typeof recipe.is_locked === 'boolean') return recipe.is_locked;
  if (typeof recipe.unlocked === 'boolean') return !recipe.unlocked;

  if (typeof recipe.access === 'string') {
    const access = recipe.access.toLowerCase();
    if (access === 'locked' || access === 'restricted') return true;
    if (access === 'unlocked' || access === 'open') return false;
  }

  return false;
}

export function extractUnlocksRemaining(payload: any): number | null {
  const value = payload?.unlocks_remaining ?? payload?.unlocksRemaining ?? payload?.remaining_unlocks;
  if (value == null) return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}
